import { UpgradeButton } from "react-migration/components/UpgradeCTA";
import { HOMETRACK_ADDON_ROUTE } from "react-migration/domains/nav/components/Modals/AddOnsStoreModal/constants";
import { openAddOnsStoreModal } from "src/js/stores/navigation/actions";

type HometrackUpgradeButtonProps = {
  className?: string;
  logClickSource: string;
};

export function HometrackUpgradeButton({ logClickSource, className }: HometrackUpgradeButtonProps) {
  return (
    <UpgradeButton
      onClick={() => {
        openAddOnsStoreModal({
          path: HOMETRACK_ADDON_ROUTE,
          logClickSource,
        });
      }}
      className={className}
    />
  );
}
